import { ActionInfo } from "./ActionInfoTypes";

// -----
// *** CAPACITY ACTIONS ***
// -----

//
// Basic Increase Capacity Actions (+10)
//

export const IncreaseCapacity_3005: ActionInfo = {
  id: "increase_capacity_3005",
  type: "Capacity",
  title: "Brick 1x1 (+10)",
  details: "+10 Capacity Brick 1x1",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 15,
    },
    {
      brickId: "3023",
      baseChangeValue: 15,
    },
    {
      brickId: "3024",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [
    {
      actionId: "brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: false,
};

export const IncreaseCapacity_3004: ActionInfo = {
  id: "increase_capacity_3004",
  type: "Capacity",
  title: "Brick 1x2 (+10)",
  details: "+10 Capacity Brick 1x2",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 15,
    },
    {
      brickId: "3004",
      baseChangeValue: 15,
    },
    {
      brickId: "3024",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [
    {
      actionId: "brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: false,
};

export const IncreaseCapacity_3010: ActionInfo = {
  id: "increase_capacity_3010",
  type: "Capacity",
  title: "Brick 1x4 (+10)",
  details: "+10 Capacity Brick 1x4",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 25,
    },
    {
      brickId: "3004",
      baseChangeValue: 15,
    },
    {
      brickId: "3024",
      baseChangeValue: 18,
    },
    {
      brickId: "4286",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3003: ActionInfo = {
  id: "increase_capacity_3003",
  type: "Capacity",
  title: "Brick 2x2 (+10)",
  details: "+10 Capacity Brick 2x2",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 25,
    },
    {
      brickId: "3004",
      baseChangeValue: 15,
    },
    {
      brickId: "3023",
      baseChangeValue: 18,
    },
    {
      brickId: "3039",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3001: ActionInfo = {
  id: "increase_capacity_3001",
  type: "Capacity",
  title: "Brick 2x4 (+10)",
  details: "+10 Capacity Brick 2x4",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 20,
    },
    {
      brickId: "3024",
      baseChangeValue: 20,
    },
    {
      brickId: "3660",
      baseChangeValue: 10,
    },
    {
      brickId: "2752",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3024: ActionInfo = {
  id: "increase_capacity_3024",
  type: "Capacity",
  title: "Plate 1x1 (+10)",
  details: "+10 Capacity Plate 1x1",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 10,
    },
    {
      brickId: "3004",
      baseChangeValue: 15,
    },
    {
      brickId: "3024",
      baseChangeValue: 18,
    },
    {
      brickId: "3023",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [
    {
      actionId: "brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: false,
};

export const IncreaseCapacity_3023: ActionInfo = {
  id: "increase_capacity_3023",
  type: "Capacity",
  title: "Plate 1x2 (+10)",
  details: "+10 Capacity Plate 1x2",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 10,
    },
    {
      brickId: "3004",
      baseChangeValue: 15,
    },
    {
      brickId: "3023",
      baseChangeValue: 10,
    },
    {
      brickId: "3024",
      baseChangeValue: 18,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [
    {
      actionId: "brickpack_sloped_bricks_part_one",
    },
    {
      actionId: "brickpack_minifig_utensils_part_one",
    },
    {
      actionId: "brickpack_bionicles_part_one",
    },
  ],
  isBrickpack: false,
};

export const IncreaseCapacity_3710: ActionInfo = {
  id: "increase_capacity_3710",
  type: "Capacity",
  title: "Plate 1x4 (+10)",
  details: "+10 Capacity Brick 1x4",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 25,
    },
    {
      brickId: "3023",
      baseChangeValue: 20,
    },
    {
      brickId: "6091",
      baseChangeValue: 10,
    },
    {
      brickId: "60477",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3022: ActionInfo = {
  id: "increase_capacity_3022",
  type: "Capacity",
  title: "Plate 2x2 (+10)",
  details: "+10 Capacity Brick 2x2",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 25,
    },
    {
      brickId: "3004",
      baseChangeValue: 25,
    },
    {
      brickId: "3023",
      baseChangeValue: 25,
    },
    {
      brickId: "3024",
      baseChangeValue: 20,
    },
    {
      brickId: "54200",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3020: ActionInfo = {
  id: "increase_capacity_3020",
  type: "Capacity",
  title: "Plate 2x4 (+10)",
  details: "+10 Capacity Brick 2x4",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 25,
    },
    {
      brickId: "3004",
      baseChangeValue: 25,
    },
    {
      brickId: "3023",
      baseChangeValue: 25,
    },
    {
      brickId: "3024",
      baseChangeValue: 20,
    },
    {
      brickId: "30363",
      baseChangeValue: 20,
    },
    {
      brickId: "4286",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Increase Capacity +100 Actions
//

export const IncreaseCapacity_3005_100: ActionInfo = {
  id: "increase_capacity_3005_100",
  type: "Capacity",
  title: "Brick 1x1 (+100)",
  details: "+100 Capacity Brick 1x1",
  cost: [
    {
      brickId: "3040",
      baseChangeValue: 35,
    },
    {
      brickId: "2752",
      baseChangeValue: 20,
    },
    {
      brickId: "30228",
      baseChangeValue: 20,
    },
    {
      brickId: "42760",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3004_100: ActionInfo = {
  id: "increase_capacity_3004_100",
  type: "Capacity",
  title: "Brick 1x2 (+100)",
  details: "+100 Capacity Brick 1x2",
  cost: [
    {
      brickId: "6246a",
      baseChangeValue: 20,
    },
    {
      brickId: "3962a",
      baseChangeValue: 20,
    },
    {
      brickId: "32553",
      baseChangeValue: 10,
    },
    {
      brickId: "54271",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3024_100: ActionInfo = {
  id: "increase_capacity_3024_100",
  type: "Capacity",
  title: "Plate 1x1 (+100)",
  details: "+100 Capacity Plate 1x1",
  cost: [
    {
      brickId: "30228",
      baseChangeValue: 20,
    },
    {
      brickId: "42760",
      baseChangeValue: 10,
    },
    {
      brickId: "47298",
      baseChangeValue: 10,
    },
    {
      brickId: "x346",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3023_100: ActionInfo = {
  id: "increase_capacity_3023_100",
  type: "Capacity",
  title: "Plate 1x2 (+100)",
  details: "+100 Capacity Plate 1x2",
  cost: [
    {
      brickId: "30304",
      baseChangeValue: 20,
    },
    {
      brickId: "43558",
      baseChangeValue: 10,
    },
    {
      brickId: "54271",
      baseChangeValue: 10,
    },
    {
      brickId: "42074",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3010_100: ActionInfo = {
  id: "increase_capacity_3010_100",
  type: "Capacity",
  title: "Brick 1x4 (+100)",
  details: "+100 Capacity Brick 1x4",
  cost: [
    {
      brickId: "30148",
      baseChangeValue: 20,
    },
    {
      brickId: "42042",
      baseChangeValue: 10,
    },
    {
      brickId: "41671",
      baseChangeValue: 10,
    },
    {
      brickId: "42074",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3003_100: ActionInfo = {
  id: "increase_capacity_3003_100",
  type: "Capacity",
  title: "Brick 2x2 (+100)",
  details: "+100 Capacity Brick 2x2",
  cost: [
    {
      brickId: "6246a",
      baseChangeValue: 20,
    },
    {
      brickId: "x346",
      baseChangeValue: 10,
    },
    {
      brickId: "54271",
      baseChangeValue: 10,
    },
    {
      brickId: "42760",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3001_100: ActionInfo = {
  id: "increase_capacity_3001_100",
  type: "Capacity",
  title: "Brick 2x4 (+100)",
  details: "+100 Capacity Brick 2x4",
  cost: [
    {
      brickId: "30162",
      baseChangeValue: 20,
    },
    {
      brickId: "43558",
      baseChangeValue: 10,
    },
    {
      brickId: "47298",
      baseChangeValue: 10,
    },
    {
      brickId: "54271",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3710_100: ActionInfo = {
  id: "increase_capacity_3710_100",
  type: "Capacity",
  title: "Plate 1x4 (+100)",
  details: "+100 Capacity Plate 1x4",
  cost: [
    {
      brickId: "93106",
      baseChangeValue: 20,
    },
    {
      brickId: "32553",
      baseChangeValue: 10,
    },
    {
      brickId: "43558",
      baseChangeValue: 10,
    },
    {
      brickId: "41671",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3022_100: ActionInfo = {
  id: "increase_capacity_3022_100",
  type: "Capacity",
  title: "Plate 2x2 (+100)",
  details: "+100 Capacity Plate 2x2",
  cost: [
    {
      brickId: "4349",
      baseChangeValue: 20,
    },
    {
      brickId: "43558",
      baseChangeValue: 10,
    },
    {
      brickId: "42760",
      baseChangeValue: 10,
    },
    {
      brickId: "47298",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3020_100: ActionInfo = {
  id: "increase_capacity_3020_100",
  type: "Capacity",
  title: "Plate 2x4 (+100)",
  details: "+100 Capacity Plate 2x4",
  cost: [
    {
      brickId: "30228",
      baseChangeValue: 20,
    },
    {
      brickId: "42042",
      baseChangeValue: 10,
    },
    {
      brickId: "54271",
      baseChangeValue: 10,
    },
    {
      brickId: "32553",
      baseChangeValue: 10,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 100,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Increase Capacity +350 Actions
//

export const IncreaseCapacity_3005_350: ActionInfo = {
  id: "increase_capacity_3005_350",
  type: "Capacity",
  title: "Brick 1x1 (+350)",
  details: "+350 Capacity Brick 1x1",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 4000,
    },
    {
      brickId: "32553",
      baseChangeValue: 3000,
    },
    {
      brickId: "6086",
      baseChangeValue: 400,
    },
    {
      brickId: "30229",
      baseChangeValue: 300,
    },
    {
      brickId: "32565",
      baseChangeValue: 200,
    },
    {
      brickId: "30360",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3004_350: ActionInfo = {
  id: "increase_capacity_3004_350",
  type: "Capacity",
  title: "Brick 1x2 (+350)",
  details: "+350 Capacity Brick 1x2",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 4000,
    },
    {
      brickId: "42042",
      baseChangeValue: 3000,
    },
    {
      brickId: "92084",
      baseChangeValue: 400,
    },
    {
      brickId: "64567",
      baseChangeValue: 300,
    },
    {
      brickId: "32574",
      baseChangeValue: 200,
    },
    {
      brickId: "2489",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3024_350: ActionInfo = {
  id: "increase_capacity_3024_350",
  type: "Capacity",
  title: "Plate 1x1 (+350)",
  details: "+350 Capacity Plate 1x1",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 4000,
    },
    {
      brickId: "43558",
      baseChangeValue: 3000,
    },
    {
      brickId: "30238",
      baseChangeValue: 400,
    },
    {
      brickId: "76764",
      baseChangeValue: 300,
    },
    {
      brickId: "32573",
      baseChangeValue: 200,
    },
    {
      brickId: "30139",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3023_350: ActionInfo = {
  id: "increase_capacity_3023_350",
  type: "Capacity",
  title: "Plate 1x2 (+350)",
  details: "+350 Capacity Plate 1x2",
  cost: [
    {
      brickId: "3710",
      baseChangeValue: 4000,
    },
    {
      brickId: "42760",
      baseChangeValue: 3000,
    },
    {
      brickId: "48812",
      baseChangeValue: 400,
    },
    {
      brickId: "30035",
      baseChangeValue: 300,
    },
    {
      brickId: "32566",
      baseChangeValue: 200,
    },
    {
      brickId: "30360",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3010_350: ActionInfo = {
  id: "increase_capacity_3010_350",
  type: "Capacity",
  title: "Brick 1x4 (+350)",
  details: "+350 Capacity Brick 1x4",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 4000,
    },
    {
      brickId: "41671",
      baseChangeValue: 3000,
    },
    {
      brickId: "30464",
      baseChangeValue: 400,
    },
    {
      brickId: "55297",
      baseChangeValue: 300,
    },
    {
      brickId: "32570",
      baseChangeValue: 200,
    },
    {
      brickId: "6014b",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3003_350: ActionInfo = {
  id: "increase_capacity_3003_350",
  type: "Capacity",
  title: "Brick 2x2 (+350)",
  details: "+350 Capacity Brick 2x2",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 4000,
    },
    {
      brickId: "47298",
      baseChangeValue: 3000,
    },
    {
      brickId: "4493c01pb02",
      baseChangeValue: 400,
    },
    {
      brickId: "6246f",
      baseChangeValue: 300,
    },
    {
      brickId: "32575",
      baseChangeValue: 200,
    },
    {
      brickId: "50990b",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3001_350: ActionInfo = {
  id: "increase_capacity_3001_350",
  type: "Capacity",
  title: "Brick 2x4 (+350)",
  details: "+350 Capacity Brick 2x4",
  cost: [
    {
      brickId: "3020",
      baseChangeValue: 4000,
    },
    {
      brickId: "x346",
      baseChangeValue: 3000,
    },
    {
      brickId: "30115",
      baseChangeValue: 400,
    },
    {
      brickId: "30229",
      baseChangeValue: 300,
    },
    {
      brickId: "32567",
      baseChangeValue: 200,
    },
    {
      brickId: "3960",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3710_350: ActionInfo = {
  id: "increase_capacity_3710_350",
  type: "Capacity",
  title: "Plate 1x4 (+350)",
  details: "+350 Capacity Plate 1x4",
  cost: [
    {
      brickId: "3024",
      baseChangeValue: 4000,
    },
    {
      brickId: "42760",
      baseChangeValue: 3000,
    },
    {
      brickId: "92084",
      baseChangeValue: 400,
    },
    {
      brickId: "30194",
      baseChangeValue: 300,
    },
    {
      brickId: "32574",
      baseChangeValue: 200,
    },
    {
      brickId: "4285b",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3022_350: ActionInfo = {
  id: "increase_capacity_3022_350",
  type: "Capacity",
  title: "Plate 2x2 (+350)",
  details: "+350 Capacity Plate 2x2",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 4000,
    },
    {
      brickId: "32553",
      baseChangeValue: 3000,
    },
    {
      brickId: "80674",
      baseChangeValue: 400,
    },
    {
      brickId: "30035",
      baseChangeValue: 300,
    },
    {
      brickId: "32565",
      baseChangeValue: 200,
    },
    {
      brickId: "4740",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3020_350: ActionInfo = {
  id: "increase_capacity_3020_350",
  type: "Capacity",
  title: "Plate 2x4 (+350)",
  details: "+350 Capacity Plate 2x4",
  cost: [
    {
      brickId: "3022",
      baseChangeValue: 4000,
    },
    {
      brickId: "54271",
      baseChangeValue: 3000,
    },
    {
      brickId: "33121",
      baseChangeValue: 400,
    },
    {
      brickId: "64644",
      baseChangeValue: 300,
    },
    {
      brickId: "32568",
      baseChangeValue: 200,
    },
    {
      brickId: "6222",
      baseChangeValue: 15,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 350,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Increase Capacity +1000 Actions
//

export const IncreaseCapacity_3005_1000: ActionInfo = {
  id: "increase_capacity_3005_1000",
  type: "Capacity",
  title: "Brick 1x1 (+1000)",
  details: "+1000 Capacity Brick 1x1",
  cost: [
    {
      brickId: "32567",
      baseChangeValue: 300,
    },
    {
      brickId: "32574",
      baseChangeValue: 300,
    },
    {
      brickId: "4740",
      baseChangeValue: 45,
    },
    {
      brickId: "6014b",
      baseChangeValue: 45,
    },
    {
      brickId: "3901",
      baseChangeValue: 45,
    },
    {
      brickId: "62696",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3004_1000: ActionInfo = {
  id: "increase_capacity_3004_1000",
  type: "Capacity",
  title: "Brick 1x2 (+1000)",
  details: "+1000 Capacity Brick 1x2",
  cost: [
    {
      brickId: "32570",
      baseChangeValue: 300,
    },
    {
      brickId: "32575",
      baseChangeValue: 300,
    },
    {
      brickId: "3960",
      baseChangeValue: 45,
    },
    {
      brickId: "50990b",
      baseChangeValue: 45,
    },
    {
      brickId: "53982",
      baseChangeValue: 45,
    },
    {
      brickId: "53981",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3004",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3024_1000: ActionInfo = {
  id: "increase_capacity_3024_1000",
  type: "Capacity",
  title: "Plate 1x1 (+1000)",
  details: "+1000 Capacity Plate 1x1",
  cost: [
    {
      brickId: "32566",
      baseChangeValue: 300,
    },
    {
      brickId: "32565",
      baseChangeValue: 300,
    },
    {
      brickId: "2489",
      baseChangeValue: 45,
    },
    {
      brickId: "30139",
      baseChangeValue: 45,
    },
    {
      brickId: "26139",
      baseChangeValue: 45,
    },
    {
      brickId: "42444",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3023_1000: ActionInfo = {
  id: "increase_capacity_3023_1000",
  type: "Capacity",
  title: "Plate 1x2 (+1000)",
  details: "+1000 Capacity Plate 1x2",
  cost: [
    {
      brickId: "32571",
      baseChangeValue: 300,
    },
    {
      brickId: "32568",
      baseChangeValue: 300,
    },
    {
      brickId: "6222",
      baseChangeValue: 45,
    },
    {
      brickId: "41531",
      baseChangeValue: 45,
    },
    {
      brickId: "30410",
      baseChangeValue: 45,
    },
    {
      brickId: "87991",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3010_1000: ActionInfo = {
  id: "increase_capacity_3010_1000",
  type: "Capacity",
  title: "Brick 1x4 (+1000)",
  details: "+1000 Capacity Brick 1x4",
  cost: [
    {
      brickId: "32505",
      baseChangeValue: 300,
    },
    {
      brickId: "32573",
      baseChangeValue: 300,
    },
    {
      brickId: "30360",
      baseChangeValue: 45,
    },
    {
      brickId: "4285b",
      baseChangeValue: 45,
    },
    {
      brickId: "13768",
      baseChangeValue: 45,
    },
    {
      brickId: "37784",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3010",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3003_1000: ActionInfo = {
  id: "increase_capacity_3003_1000",
  type: "Capacity",
  title: "Brick 2x2 (+1000)",
  details: "+1000 Capacity Brick 2x2",
  cost: [
    {
      brickId: "32567",
      baseChangeValue: 300,
    },
    {
      brickId: "32566",
      baseChangeValue: 300,
    },
    {
      brickId: "4740",
      baseChangeValue: 45,
    },
    {
      brickId: "2489",
      baseChangeValue: 45,
    },
    {
      brickId: "3901",
      baseChangeValue: 45,
    },
    {
      brickId: "26139",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3003",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3001_1000: ActionInfo = {
  id: "increase_capacity_3001_1000",
  type: "Capacity",
  title: "Brick 2x4 (+1000)",
  details: "+1000 Capacity Brick 2x4",
  cost: [
    {
      brickId: "32574",
      baseChangeValue: 300,
    },
    {
      brickId: "32570",
      baseChangeValue: 300,
    },
    {
      brickId: "6014b",
      baseChangeValue: 45,
    },
    {
      brickId: "3960",
      baseChangeValue: 45,
    },
    {
      brickId: "62696",
      baseChangeValue: 45,
    },
    {
      brickId: "53982",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3001",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3710_1000: ActionInfo = {
  id: "increase_capacity_3710_1000",
  type: "Capacity",
  title: "Plate 1x4 (+1000)",
  details: "+1000 Capacity Plate 1x4",
  cost: [
    {
      brickId: "32575",
      baseChangeValue: 300,
    },
    {
      brickId: "32565",
      baseChangeValue: 300,
    },
    {
      brickId: "50990b",
      baseChangeValue: 45,
    },
    {
      brickId: "30139",
      baseChangeValue: 45,
    },
    {
      brickId: "53981",
      baseChangeValue: 45,
    },
    {
      brickId: "42444",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3022_1000: ActionInfo = {
  id: "increase_capacity_3022_1000",
  type: "Capacity",
  title: "Plate 2x2 (+1000)",
  details: "+1000 Capacity Plate 2x2",
  cost: [
    {
      brickId: "32571",
      baseChangeValue: 300,
    },
    {
      brickId: "32505",
      baseChangeValue: 300,
    },
    {
      brickId: "6222",
      baseChangeValue: 45,
    },
    {
      brickId: "30360",
      baseChangeValue: 45,
    },
    {
      brickId: "30410",
      baseChangeValue: 45,
    },
    {
      brickId: "13768",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_3020_1000: ActionInfo = {
  id: "increase_capacity_3020_1000",
  type: "Capacity",
  title: "Plate 2x4 (+1000)",
  details: "+1000 Capacity Plate 2x4",
  cost: [
    {
      brickId: "32568",
      baseChangeValue: 300,
    },
    {
      brickId: "32573",
      baseChangeValue: 300,
    },
    {
      brickId: "41531",
      baseChangeValue: 45,
    },
    {
      brickId: "4285b",
      baseChangeValue: 45,
    },
    {
      brickId: "87991",
      baseChangeValue: 45,
    },
    {
      brickId: "37784",
      baseChangeValue: 45,
    },
    {
      brickId: "7146-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "71766-1",
      baseChangeValue: 15,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 1000,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

//
// Brick Pack Capacity Actions (+10)
//

export const IncreaseCapacity_BrickPack_SlopedBricksPartOne: ActionInfo = {
  id: "increase_capacity_brickpack_sloped_bricks_part_one",
  type: "Capacity",
  title: "Sloped Bricks #1 (+10)",
  details: "+10 Capacity Sloped Bricks #1",
  cost: [
    {
      brickId: "3710",
      baseChangeValue: 50,
    },
    {
      brickId: "3039",
      baseChangeValue: 20,
    },
    {
      brickId: "3660",
      baseChangeValue: 20,
    },
    {
      brickId: "2752",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "54200",
      baseChangeValue: 10,
    },
    {
      brickId: "3040",
      baseChangeValue: 10,
    },
    {
      brickId: "4286",
      baseChangeValue: 10,
    },
    {
      brickId: "60477",
      baseChangeValue: 10,
    },
    {
      brickId: "3039",
      baseChangeValue: 10,
    },
    {
      brickId: "30363",
      baseChangeValue: 10,
    },
    {
      brickId: "3660",
      baseChangeValue: 10,
    },
    {
      brickId: "2752",
      baseChangeValue: 10,
    },
    {
      brickId: "30390",
      baseChangeValue: 10,
    },
    {
      brickId: "6091",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [
    {
      actionId: "buy_set_6772-1",
    },
    {
      actionId: "buy_set_8534-1",
    },
    {
      actionId: "buy_set_4866-1",
    },
    {
      actionId: "buy_set_10307-1",
    },
    {
      actionId: "buy_set_4432-1",
    },
    {
      actionId: "buy_set_21060-1",
    },
    {
      actionId: "buy_set_7146-1",
    },
    {
      actionId: "buy_set_71766-1",
    },
    {
      actionId: "buy_set_10305-1",
    },
    {
      actionId: "buy_set_75192-1",
    },
    {
      actionId: "buy_set_10179-1",
    },
  ],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigUtensilsPartOne: ActionInfo = {
  id: "increase_capacity_brickpack_minifig_utensils_part_one",
  type: "Capacity",
  title: "Minifig Utensls #1 (+10)",
  details: "+10 Capacity Minifig Utensls #1",
  cost: [
    {
      brickId: "3020",
      baseChangeValue: 50,
    },
    {
      brickId: "30162",
      baseChangeValue: 20,
    },
    {
      brickId: "30148",
      baseChangeValue: 20,
    },
    {
      brickId: "93106",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "4349",
      baseChangeValue: 10,
    },
    {
      brickId: "30162",
      baseChangeValue: 10,
    },
    {
      brickId: "30228",
      baseChangeValue: 10,
    },
    {
      brickId: "6246a",
      baseChangeValue: 10,
    },
    {
      brickId: "30148",
      baseChangeValue: 10,
    },
    {
      brickId: "93106",
      baseChangeValue: 10,
    },
    {
      brickId: "4449",
      baseChangeValue: 10,
    },
    {
      brickId: "30304",
      baseChangeValue: 10,
    },
    {
      brickId: "3962a",
      baseChangeValue: 10,
    },
    {
      brickId: "3835",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [
    {
      actionId: "buy_set_6772-1",
    },
    {
      actionId: "buy_set_8534-1",
    },
    {
      actionId: "buy_set_4866-1",
    },
    {
      actionId: "buy_set_10307-1",
    },
    {
      actionId: "buy_set_4432-1",
    },
    {
      actionId: "buy_set_21060-1",
    },
    {
      actionId: "buy_set_7146-1",
    },
  ],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_BioniclesPartOne: ActionInfo = {
  id: "increase_capacity_brickpack_bionicles_part_one",
  type: "Capacity",
  title: "Bionicles #1 (+10)",
  details: "+10 Capacity Bionicles #1",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 50,
    },
    {
      brickId: "42760",
      baseChangeValue: 20,
    },
    {
      brickId: "32506",
      baseChangeValue: 20,
    },
    {
      brickId: "42042",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "x346",
      baseChangeValue: 10,
    },
    {
      brickId: "42074",
      baseChangeValue: 10,
    },
    {
      brickId: "32553",
      baseChangeValue: 10,
    },
    {
      brickId: "42760",
      baseChangeValue: 10,
    },
    {
      brickId: "32506",
      baseChangeValue: 10,
    },
    {
      brickId: "42042",
      baseChangeValue: 10,
    },
    {
      brickId: "43558",
      baseChangeValue: 10,
    },
    {
      brickId: "41671",
      baseChangeValue: 10,
    },
    {
      brickId: "54271",
      baseChangeValue: 10,
    },
    {
      brickId: "47298",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [
    {
      actionId: "buy_set_6772-1",
    },
    {
      actionId: "buy_set_8534-1",
    },
    {
      actionId: "buy_set_4866-1",
    },
    {
      actionId: "buy_set_10307-1",
    },
    {
      actionId: "buy_set_4432-1",
    },
    {
      actionId: "buy_set_21060-1",
    },
    {
      actionId: "buy_set_7146-1",
    },
  ],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_AnimalsPartOne: ActionInfo = {
  id: "increase_capacity_brickpack_animals_part_one",
  type: "Capacity",
  title: "Animals #1 (+10)",
  details: "+10 Capacity Animals #1",
  cost: [
    {
      brickId: "3022",
      baseChangeValue: 750,
    },
    {
      brickId: "30115",
      baseChangeValue: 20,
    },
    {
      brickId: "92084",
      baseChangeValue: 20,
    },
    {
      brickId: "80674",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "4493c01pb02",
      baseChangeValue: 10,
    },
    {
      brickId: "6086",
      baseChangeValue: 10,
    },
    {
      brickId: "48812",
      baseChangeValue: 10,
    },
    {
      brickId: "30464",
      baseChangeValue: 10,
    },
    {
      brickId: "30103",
      baseChangeValue: 10,
    },
    {
      brickId: "30115",
      baseChangeValue: 10,
    },
    {
      brickId: "92084",
      baseChangeValue: 10,
    },
    {
      brickId: "80674",
      baseChangeValue: 10,
    },
    {
      brickId: "33121",
      baseChangeValue: 10,
    },
    {
      brickId: "30238",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo: ActionInfo = {
  id: "increase_capacity_brickpack_minifig_utensils_part_two",
  type: "Capacity",
  title: "Minifig Utnls #2 (+10)",
  details: "+10 Capacity Minifig Utensils #2",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 750,
    },
    {
      brickId: "55297",
      baseChangeValue: 20,
    },
    {
      brickId: "36752a",
      baseChangeValue: 20,
    },
    {
      brickId: "30229",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "30035",
      baseChangeValue: 10,
    },
    {
      brickId: "30173",
      baseChangeValue: 10,
    },
    {
      brickId: "76764",
      baseChangeValue: 10,
    },
    {
      brickId: "64644",
      baseChangeValue: 10,
    },
    {
      brickId: "6246f",
      baseChangeValue: 10,
    },
    {
      brickId: "55297",
      baseChangeValue: 10,
    },
    {
      brickId: "36752a",
      baseChangeValue: 10,
    },
    {
      brickId: "30229",
      baseChangeValue: 10,
    },
    {
      brickId: "30194",
      baseChangeValue: 10,
    },
    {
      brickId: "64567",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_BioniclesPartTwo: ActionInfo = {
  id: "increase_capacity_brickpack_bionicles_part_two",
  type: "Capacity",
  title: "Bionicles #2 (+10)",
  details: "+10 Capacity Bionicles #2",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 750,
    },
    {
      brickId: "32565",
      baseChangeValue: 20,
    },
    {
      brickId: "32571",
      baseChangeValue: 20,
    },
    {
      brickId: "32568",
      baseChangeValue: 20,
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "32567",
      baseChangeValue: 10,
    },
    {
      brickId: "32574",
      baseChangeValue: 10,
    },
    {
      brickId: "32570",
      baseChangeValue: 10,
    },
    {
      brickId: "32575",
      baseChangeValue: 10,
    },
    {
      brickId: "32566",
      baseChangeValue: 10,
    },
    {
      brickId: "32565",
      baseChangeValue: 10,
    },
    {
      brickId: "32571",
      baseChangeValue: 10,
    },
    {
      brickId: "32568",
      baseChangeValue: 10,
    },
    {
      brickId: "32505",
      baseChangeValue: 10,
    },
    {
      brickId: "32573",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_CircularBricks: ActionInfo = {
  id: "increase_capacity_brickpack_circular_bricks",
  type: "Capacity",
  title: "Circular Bricks (+10)",
  details: "+10 Capacity Circular Bricks",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 750,
    },
    {
      brickId: "32570",
      baseChangeValue: 30,
    },
    {
      brickId: "32505",
      baseChangeValue: 30,
    },
    {
      brickId: "3960",
      baseChangeValue: 30,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "4740",
      baseChangeValue: 10,
    },
    {
      brickId: "6014b",
      baseChangeValue: 10,
    },
    {
      brickId: "3960",
      baseChangeValue: 10,
    },
    {
      brickId: "50990b",
      baseChangeValue: 10,
    },
    {
      brickId: "2489",
      baseChangeValue: 10,
    },
    {
      brickId: "30139",
      baseChangeValue: 10,
    },
    {
      brickId: "6222",
      baseChangeValue: 10,
    },
    {
      brickId: "41531",
      baseChangeValue: 10,
    },
    {
      brickId: "30360",
      baseChangeValue: 10,
    },
    {
      brickId: "4285b",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_SlopedBricksPartOne_75: ActionInfo = {
  id: "increase_capacity_brickpack_sloped_bricks_part_one_75",
  type: "Capacity",
  title: "Sloped Bricks #1 (+75)",
  details: "+75 Capacity Sloped Bricks #1",
  cost: [
    {
      brickId: "3710",
      baseChangeValue: 150,
    },
    {
      brickId: "3039",
      baseChangeValue: 60,
    },
    {
      brickId: "3660",
      baseChangeValue: 60,
    },
    {
      brickId: "2752",
      baseChangeValue: 60,
    },
    {
      brickId: "8534-1",
      baseChangeValue: 10,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "54200",
      baseChangeValue: 75,
    },
    {
      brickId: "3040",
      baseChangeValue: 75,
    },
    {
      brickId: "4286",
      baseChangeValue: 75,
    },
    {
      brickId: "60477",
      baseChangeValue: 75,
    },
    {
      brickId: "3039",
      baseChangeValue: 75,
    },
    {
      brickId: "30363",
      baseChangeValue: 75,
    },
    {
      brickId: "3660",
      baseChangeValue: 75,
    },
    {
      brickId: "2752",
      baseChangeValue: 75,
    },
    {
      brickId: "30390",
      baseChangeValue: 75,
    },
    {
      brickId: "6091",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigUtensilsPartOne_75: ActionInfo =
  {
    id: "increase_capacity_brickpack_minifig_utensils_part_one_75",
    type: "Capacity",
    title: "Minifig Utnls #1 (+75)",
    details: "+75 Capacity Minifig Utensils #1",
    cost: [
      {
        brickId: "3020",
        baseChangeValue: 150,
      },
      {
        brickId: "30162",
        baseChangeValue: 60,
      },
      {
        brickId: "30148",
        baseChangeValue: 60,
      },
      {
        brickId: "93106",
        baseChangeValue: 60,
      },
      {
        brickId: "4866-1",
        baseChangeValue: 10,
        type: "set",
      },
    ],
    costIncrement: 3,
    outcome: [
      {
        brickId: "4349",
        baseChangeValue: 75,
      },
      {
        brickId: "30162",
        baseChangeValue: 75,
      },
      {
        brickId: "30228",
        baseChangeValue: 75,
      },
      {
        brickId: "6246a",
        baseChangeValue: 75,
      },
      {
        brickId: "30148",
        baseChangeValue: 75,
      },
      {
        brickId: "93106",
        baseChangeValue: 75,
      },
      {
        brickId: "4449",
        baseChangeValue: 75,
      },
      {
        brickId: "30304",
        baseChangeValue: 75,
      },
      {
        brickId: "3962a",
        baseChangeValue: 75,
      },
      {
        brickId: "3835",
        baseChangeValue: 75,
      },
    ],
    actionVisibility: [],
    isBrickpack: false,
  };

export const IncreaseCapacity_BrickPack_BioniclesPartOne_75: ActionInfo = {
  id: "increase_capacity_brickpack_bionicles_part_one_75",
  type: "Capacity",
  title: "Bionicles #1 (+75)",
  details: "+75 Capacity Bionicles #1",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 150,
    },
    {
      brickId: "42760",
      baseChangeValue: 60,
    },
    {
      brickId: "32506",
      baseChangeValue: 60,
    },
    {
      brickId: "42042",
      baseChangeValue: 60,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 50,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "x346",
      baseChangeValue: 75,
    },
    {
      brickId: "42074",
      baseChangeValue: 75,
    },
    {
      brickId: "32553",
      baseChangeValue: 75,
    },
    {
      brickId: "42760",
      baseChangeValue: 75,
    },
    {
      brickId: "32506",
      baseChangeValue: 75,
    },
    {
      brickId: "42042",
      baseChangeValue: 75,
    },
    {
      brickId: "43558",
      baseChangeValue: 75,
    },
    {
      brickId: "41671",
      baseChangeValue: 75,
    },
    {
      brickId: "54271",
      baseChangeValue: 75,
    },
    {
      brickId: "47298",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_AnimalsPartOne_75: ActionInfo = {
  id: "increase_capacity_brickpack_animals_part_one_75",
  type: "Capacity",
  title: "Animals #1 (+75)",
  details: "+75 Capacity Animals #1",
  cost: [
    {
      brickId: "3022",
      baseChangeValue: 2250,
    },
    {
      brickId: "30115",
      baseChangeValue: 60,
    },
    {
      brickId: "92084",
      baseChangeValue: 60,
    },
    {
      brickId: "80674",
      baseChangeValue: 60,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 50,
      type: "set",
    },
    {
      brickId: "7146-1",
      baseChangeValue: 2,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "4493c01pb02",
      baseChangeValue: 75,
    },
    {
      brickId: "6086",
      baseChangeValue: 75,
    },
    {
      brickId: "48812",
      baseChangeValue: 75,
    },
    {
      brickId: "30464",
      baseChangeValue: 75,
    },
    {
      brickId: "30103",
      baseChangeValue: 75,
    },
    {
      brickId: "30115",
      baseChangeValue: 75,
    },
    {
      brickId: "92084",
      baseChangeValue: 75,
    },
    {
      brickId: "80674",
      baseChangeValue: 75,
    },
    {
      brickId: "33121",
      baseChangeValue: 75,
    },
    {
      brickId: "30238",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo_75: ActionInfo =
  {
    id: "increase_capacity_brickpack_minifig_utensils_part_two_75",
    type: "Capacity",
    title: "Minifig Utnls #2 (+75)",
    details: "+75 Capacity Minifig Utensils #2",
    cost: [
      {
        brickId: "3010",
        baseChangeValue: 2250,
      },
      {
        brickId: "30390",
        baseChangeValue: 500,
      },
      {
        brickId: "55297",
        baseChangeValue: 10,
      },
      {
        brickId: "36752a",
        baseChangeValue: 10,
      },
      {
        brickId: "30229",
        baseChangeValue: 10,
      },
      {
        brickId: "6772-1",
        baseChangeValue: 100,
        type: "set",
      },
      {
        brickId: "7146-1",
        baseChangeValue: 2,
        type: "set",
      },
    ],
    costIncrement: 3,
    outcome: [
      {
        brickId: "30035",
        baseChangeValue: 75,
      },
      {
        brickId: "30173",
        baseChangeValue: 75,
      },
      {
        brickId: "76764",
        baseChangeValue: 75,
      },
      {
        brickId: "64644",
        baseChangeValue: 75,
      },
      {
        brickId: "6246f",
        baseChangeValue: 75,
      },
      {
        brickId: "55297",
        baseChangeValue: 75,
      },
      {
        brickId: "36752a",
        baseChangeValue: 75,
      },
      {
        brickId: "30229",
        baseChangeValue: 75,
      },
      {
        brickId: "30194",
        baseChangeValue: 75,
      },
      {
        brickId: "64567",
        baseChangeValue: 75,
      },
    ],
    actionVisibility: [],
    isBrickpack: false,
  };

export const IncreaseCapacity_BrickPack_BioniclesPartTwo_75: ActionInfo = {
  id: "increase_capacity_brickpack_bionicles_part_two_75",
  type: "Capacity",
  title: "Bionicles #2 (+75)",
  details: "+75 Capacity Bionicles #2",
  cost: [
    {
      brickId: "3023",
      baseChangeValue: 2250,
    },
    {
      brickId: "3710",
      baseChangeValue: 2250,
    },
    {
      brickId: "32565",
      baseChangeValue: 20,
    },
    {
      brickId: "32571",
      baseChangeValue: 20,
    },
    {
      brickId: "32568",
      baseChangeValue: 20,
    },
    {
      brickId: "6772-1",
      baseChangeValue: 100,
      type: "set",
    },
    {
      brickId: "7146-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "32567",
      baseChangeValue: 75,
    },
    {
      brickId: "32574",
      baseChangeValue: 75,
    },
    {
      brickId: "32570",
      baseChangeValue: 75,
    },
    {
      brickId: "32575",
      baseChangeValue: 75,
    },
    {
      brickId: "32566",
      baseChangeValue: 75,
    },
    {
      brickId: "32565",
      baseChangeValue: 75,
    },
    {
      brickId: "32571",
      baseChangeValue: 75,
    },
    {
      brickId: "32568",
      baseChangeValue: 75,
    },
    {
      brickId: "32505",
      baseChangeValue: 75,
    },
    {
      brickId: "32573",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigHair: ActionInfo = {
  id: "increase_capacity_brickpack_minifig_hair",
  type: "Capacity",
  title: "Minifig Hair (+10)",
  details: "+10 Capacity Minifig Hair",
  cost: [
    {
      brickId: "32575",
      baseChangeValue: 40,
    },
    {
      brickId: "32574",
      baseChangeValue: 40,
    },
    {
      brickId: "3960",
      baseChangeValue: 30,
    },
    {
      brickId: "41531",
      baseChangeValue: 30,
    },
    {
      brickId: "21060-1",
      baseChangeValue: 1,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3901",
      baseChangeValue: 10,
    },
    {
      brickId: "62696",
      baseChangeValue: 10,
    },
    {
      brickId: "53982",
      baseChangeValue: 10,
    },
    {
      brickId: "53981",
      baseChangeValue: 10,
    },
    {
      brickId: "26139",
      baseChangeValue: 10,
    },
    {
      brickId: "42444",
      baseChangeValue: 10,
    },
    {
      brickId: "30410",
      baseChangeValue: 10,
    },
    {
      brickId: "87991",
      baseChangeValue: 10,
    },
    {
      brickId: "13768",
      baseChangeValue: 10,
    },
    {
      brickId: "37784",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_TechnicBricks: ActionInfo = {
  id: "increase_capacity_brickpack_technic_bricks",
  type: "Capacity",
  title: "Technic Bricks (+10)",
  details: "+10 Capacity Technic Bricks",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 4000,
    },
    {
      brickId: "3713",
      baseChangeValue: 30,
    },
    {
      brickId: "3749",
      baseChangeValue: 30,
    },
    {
      brickId: "24316",
      baseChangeValue: 30,
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3713",
      baseChangeValue: 10,
    },
    {
      brickId: "3749",
      baseChangeValue: 10,
    },
    {
      brickId: "24316",
      baseChangeValue: 10,
    },
    {
      brickId: "73230",
      baseChangeValue: 10,
    },
    {
      brickId: "3701",
      baseChangeValue: 10,
    },
    {
      brickId: "32174",
      baseChangeValue: 10,
    },
    {
      brickId: "32034",
      baseChangeValue: 10,
    },
    {
      brickId: "3648",
      baseChangeValue: 10,
    },
    {
      brickId: "3736",
      baseChangeValue: 10,
    },
    {
      brickId: "32168",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigHeadgear: ActionInfo = {
  id: "increase_capacity_brickpack_minifig_headgear",
  type: "Capacity",
  title: "Minifig Headgear (+10)",
  details: "+10 Capacity Minifig Headgear",
  cost: [
    {
      brickId: "3648",
      baseChangeValue: 20,
    },
    {
      brickId: "73230",
      baseChangeValue: 20,
    },
    {
      brickId: "26139",
      baseChangeValue: 30,
    },
    {
      brickId: "53981",
      baseChangeValue: 30,
    },
    {
      brickId: "21060-1",
      baseChangeValue: 3,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3898",
      baseChangeValue: 10,
    },
    {
      brickId: "30202",
      baseChangeValue: 10,
    },
    {
      brickId: "x164",
      baseChangeValue: 10,
    },
    {
      brickId: "3485",
      baseChangeValue: 10,
    },
    {
      brickId: "x52",
      baseChangeValue: 10,
    },
    {
      brickId: "2528",
      baseChangeValue: 10,
    },
    {
      brickId: "3624",
      baseChangeValue: 10,
    },
    {
      brickId: "30325",
      baseChangeValue: 10,
    },
    {
      brickId: "30167",
      baseChangeValue: 10,
    },
    {
      brickId: "30381",
      baseChangeValue: 10,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_CircularBricks_75: ActionInfo = {
  id: "increase_capacity_brickpack_circular_bricks_75",
  type: "Capacity",
  title: "Circular Bricks (+75)",
  details: "+75 Capacity Circular Bricks",
  cost: [
    {
      brickId: "13768",
      baseChangeValue: 60,
    },
    {
      brickId: "37784",
      baseChangeValue: 60,
    },
    {
      brickId: "3736",
      baseChangeValue: 45,
    },
    {
      brickId: "32168",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "4740",
      baseChangeValue: 75,
    },
    {
      brickId: "6014b",
      baseChangeValue: 75,
    },
    {
      brickId: "3960",
      baseChangeValue: 75,
    },
    {
      brickId: "50990b",
      baseChangeValue: 75,
    },
    {
      brickId: "2489",
      baseChangeValue: 75,
    },
    {
      brickId: "30139",
      baseChangeValue: 75,
    },
    {
      brickId: "6222",
      baseChangeValue: 75,
    },
    {
      brickId: "41531",
      baseChangeValue: 75,
    },
    {
      brickId: "30360",
      baseChangeValue: 75,
    },
    {
      brickId: "4285b",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigHair_75: ActionInfo = {
  id: "increase_capacity_brickpack_minifig_hair_75",
  type: "Capacity",
  title: "Minifig Hair (+75)",
  details: "+75 Capacity Minifig Hair",
  cost: [
    {
      brickId: "3901",
      baseChangeValue: 60,
    },
    {
      brickId: "53982",
      baseChangeValue: 60,
    },
    {
      brickId: "3713",
      baseChangeValue: 45,
    },
    {
      brickId: "24316",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3901",
      baseChangeValue: 75,
    },
    {
      brickId: "62696",
      baseChangeValue: 75,
    },
    {
      brickId: "53982",
      baseChangeValue: 75,
    },
    {
      brickId: "53981",
      baseChangeValue: 75,
    },
    {
      brickId: "26139",
      baseChangeValue: 75,
    },
    {
      brickId: "42444",
      baseChangeValue: 75,
    },
    {
      brickId: "30410",
      baseChangeValue: 75,
    },
    {
      brickId: "87991",
      baseChangeValue: 75,
    },
    {
      brickId: "13768",
      baseChangeValue: 75,
    },
    {
      brickId: "37784",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_TechnicBricks_75: ActionInfo = {
  id: "increase_capacity_brickpack_technic_bricks_75",
  type: "Capacity",
  title: "Technic Bricks (+75)",
  details: "+75 Capacity Technic Bricks",
  cost: [
    {
      brickId: "62696",
      baseChangeValue: 60,
    },
    {
      brickId: "53981",
      baseChangeValue: 60,
    },
    {
      brickId: "3749",
      baseChangeValue: 45,
    },
    {
      brickId: "73230",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3713",
      baseChangeValue: 75,
    },
    {
      brickId: "3749",
      baseChangeValue: 75,
    },
    {
      brickId: "24316",
      baseChangeValue: 75,
    },
    {
      brickId: "73230",
      baseChangeValue: 75,
    },
    {
      brickId: "3701",
      baseChangeValue: 75,
    },
    {
      brickId: "32174",
      baseChangeValue: 75,
    },
    {
      brickId: "32034",
      baseChangeValue: 75,
    },
    {
      brickId: "3648",
      baseChangeValue: 75,
    },
    {
      brickId: "3736",
      baseChangeValue: 75,
    },
    {
      brickId: "32168",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};

export const IncreaseCapacity_BrickPack_MinifigHeadgear_75: ActionInfo = {
  id: "increase_capacity_brickpack_minifig_headgear_75",
  type: "Capacity",
  title: "Minifig Headgear (+75)",
  details: "+75 Capacity Minifig Headgear",
  cost: [
    {
      brickId: "26139",
      baseChangeValue: 60,
    },
    {
      brickId: "42444",
      baseChangeValue: 60,
    },
    {
      brickId: "3701",
      baseChangeValue: 45,
    },
    {
      brickId: "32174",
      baseChangeValue: 45,
    },
    {
      brickId: "71766-1",
      baseChangeValue: 25,
      type: "set",
    },
    {
      brickId: "21060-1",
      baseChangeValue: 10,
      type: "set",
    },
    {
      brickId: "10305-1",
      baseChangeValue: 5,
      type: "set",
    },
  ],
  costIncrement: 3,
  outcome: [
    {
      brickId: "3898",
      baseChangeValue: 75,
    },
    {
      brickId: "30202",
      baseChangeValue: 75,
    },
    {
      brickId: "x164",
      baseChangeValue: 75,
    },
    {
      brickId: "3485",
      baseChangeValue: 75,
    },
    {
      brickId: "x52",
      baseChangeValue: 75,
    },
    {
      brickId: "2528",
      baseChangeValue: 75,
    },
    {
      brickId: "3624",
      baseChangeValue: 75,
    },
    {
      brickId: "30325",
      baseChangeValue: 75,
    },
    {
      brickId: "30167",
      baseChangeValue: 75,
    },
    {
      brickId: "30381",
      baseChangeValue: 75,
    },
  ],
  actionVisibility: [],
  isBrickpack: false,
};
